export default "__VITE_ASSET__C4At7na$__"